import { Toggle } from "components/ui/toggle";
import React from "react";

interface BulkCommunityToggleProps {
    value: boolean;
    onChange: (value: boolean) => void;
    disabled?: boolean;
}

export const BulkCommunityToggle: React.FC<BulkCommunityToggleProps> = ({
    value,
    onChange,
    disabled,
}) => {
    return (
        <div className="group">
            <Toggle
                checked={value}
                onChange={onChange}
                disabled={disabled}
                label={
                    <div>
                        <span className="text-md">
                            Enable bulk add in &quot;Find Ideal Communities&quot;
                        </span>
                        <div className="text-gray-500 group-hover:text-gray-900 text-sm">
                            Allow users to add multiple communities at once when searching
                            for communities in the client profile.
                        </div>
                    </div>
                }
            />
        </div>
    );
};
